/**
 * Stepping away without saying so.
 *
 * Auto-assign hands chats to whoever is "online" with a console open. An
 * operator who went to lunch with the tab open is both, so the chat they are
 * given sits unanswered while looking taken — the case lib/assign.ts on the
 * server calls out and cannot detect. After ten minutes without a key press
 * or a pointer movement the console marks them away itself, and puts them
 * back the moment they touch it again.
 *
 * Only ever undoes its own doing: an operator who *chose* away stays away
 * however much they move the mouse.
 */

export const IDLE_AFTER_MS = 10 * 60_000;

export type Presence = "online" | "away";

export interface IdleState {
  presence: Presence;
  /** True while "away" is this module's doing rather than the operator's. */
  auto: boolean;
}

/** What the state should be after `idleFor` ms without input, or null for no change. */
export function afterIdle(state: IdleState, idleFor: number, threshold = IDLE_AFTER_MS): IdleState | null {
  if (state.presence === "online" && idleFor >= threshold) return { presence: "away", auto: true };
  return null;
}

/** What the state should be once the operator does something, or null for no change. */
export function afterActivity(state: IdleState): IdleState | null {
  if (state.presence === "away" && state.auto) return { presence: "online", auto: false };
  return null;
}
